import axios from "axios";

// Models
import CountWrapper from "../Models/DTOs/CountWrapper";
import PublicAuthorDTO from "../Models/DTOs/PublicAuthorDTO";

const WEB_API_URL = process.env.REACT_APP_WEB_API_URL ?? "/";

export async function GetPublicAuthors(
    abortController: AbortController,
    take = 100,
    skip = 0
): Promise<CountWrapper<PublicAuthorDTO>> {
    const response = await axios.get<CountWrapper<PublicAuthorDTO>>(
        `${WEB_API_URL}v1/authors`,
        {
            params: { take, skip },
            signal: abortController.signal,
        }
    );

    return response.data;
}
